import { string } from 'prop-types'

import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/matter-types'
const baseFunctions = GetBaseServiceFunctions(BaseRoute)
function GetListMatterType(params = {}) {
  return ApiRequest.get(`${BaseRoute}/listMatterType`, {
    params: { ...params },
  })
}
function GetListTypeOfClaim(params = {} as any) {
  return ApiRequest.get(
    `${BaseRoute}/${params.matterTypeId}/listTypeOfClaim`,
    {
      params: { ...params },
    }
  )
}
function GetListTypeOfReport(params = {} as any) {
  if (params.typeOfClaimId) {
    return ApiRequest.get(
      `${BaseRoute}/${params.matterTypeId}/${params.typeOfClaimId}/listTypeOfReport`,
      {
        params: { ...params },
      }
    )
  }
  return ApiRequest.get(
    `${BaseRoute}/${params.matterTypeId}/listTypeOfReport`,
    {
      params: { ...params },
    }
  )
}
const API = {
  ...baseFunctions,
  GetListMatterType,
  GetListTypeOfClaim,
  GetListTypeOfReport,
}

export default API
